import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../Loaders/DnaLoader";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthService from "../../pages/Authentication/auth.service";
import Alerts from "../Alerts/alerts";
import { Col, CardBody, Card } from "reactstrap";
import PermissionAccess from '../../PermissionAccess/Access.js';

const API_BASE_URL = process.env.REACT_APP_APIURL;

const AddDocumentModal = ({ showModalAddDocument, handleToggleModalAddDocument, onSuccess }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [data, setData] = useState({
    title: '',
    icon: '',
    type: '',
    status: 'active',
  });

  const [errors, setErrors] = useState({
    title: '',
    icon: '',
    type: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target || e;
    let error = '';
  
    if (name === 'title' && !value) {
      error = 'Title is required';
    } else if (name === 'icon' && !value) {
      error = 'Icon is required';
    } else if (name === 'type' && !value) {
      error = 'Type is required';
    }
  
    setData(prevData => ({ ...prevData, [name]: value }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: error }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!data.title) { validationErrors.title = 'Title is required'; }
    if (!data.icon) { validationErrors.icon = 'Icon is required'; }
    if (!data.type) { validationErrors.type = 'Type is required'; }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      const requestData = {
        functionName: 'AddMerchantDoc',
        postData: data
      };

      const headers = {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('session-id')
      };

      axios.post(`${API_BASE_URL}/AddMerchantDoc`, requestData, { headers }).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            resetForm();
            handleToggleModalAddDocument();
            onSuccess();
            setErrors({ title: '', icon: '', type: '' });
            Alerts.swalSuccessAlert(t("Document added successfully."));
          } else {
            if (response.data.message) {
              Alerts.swalErrorAlert(response.data.message);
            } else {
              validationErrors = response.data.errors || {};
              setErrors(validationErrors);
            }
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          if (typeof errContent === 'object' && errContent.message) {
            Alerts.swalErrorAlert(errContent.message);
          } else if (typeof errContent === 'string') {
            Alerts.swalErrorAlert(errContent);
          } else {
            Alerts.swalErrorAlert(t("Server Error, Please try again later."));
          }
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    }
  };

  const resetForm = () => {
    setData({
      title: '',
      icon: '',
      type: '',
      status: 'active',
    });
  };

  const handleClose = () => {
    setErrors({
      title: '',
      icon: '',
      type: '',
    });
    handleToggleModalAddDocument();
  };

  return (
    <div className={showModalAddDocument ? "modal d-block mt-4" : "modal"} style={{ display: showModalAddDocument ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{t("Add Document")}</h5>
            </div>
            <div className="modal-body">
            <Col md="12">
                <Card className="main-card mb-3">
                     <CardBody>
              <LoadingOverlay
                tag="div"
                active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="title" className="col-form-label">{t("Title")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Title" 
                      name="title"
                      onChange={handleChange}
                      value={data.title}
                      />
                      {errors.title && <strong className="error text-danger">{errors.title}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="icon" className="col-form-label">{t("Icon")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Icon" 
                      name="icon"
                      onChange={handleChange}
                      value={data.icon}
                      />
                      {errors.icon && <strong className="error text-danger">{errors.icon}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="type" className="col-form-label">{t("Type")}:</label>
                      <select className="form-control" 
                      name="type"
                      onChange={handleChange}
                      value={data.type}
                      >
                        <option value="">{t("Select Type")}</option>
                        <option value="pharmacy">{t("Pharmacy")}</option>
                        <option value="commerce">{t("Commerce")}</option>
                        <option value="both">{t("Both")}</option>
                      </select>
                      {errors.type && <strong className="error text-danger">{errors.type}</strong>}
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="text-center mt-4">
                  <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleClose}>{t("Close")}</button>
                  <button type="submit" className="btn btn-custom-color">{t("Save")}</button>
                </div>
                </div>
                                          </LoadingOverlay>
                                        </CardBody>
                                    </Card>
                                </Col>
            </div>
            
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddDocumentModal;
